import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CustomLayout from './CustomLayout.vue';
import PersonalNamePreview from "./PersonalNamePreview.vue";
import ExtAstaDxPreview from "./ExtAstaDxPreview.vue";
import ExtAstaSxPreview from "./ExtAstaSxPreview.vue";
import config from "@/config/custom-config";
let PersonalName = class PersonalName extends Vue {
  constructor() {
    super(...arguments);
    this.colors = [{
      name: "nero",
      colorCode: "#212121",
      colorClass: "grey darken-4",
      checkColor: "white"
    }, {
      name: "bianco",
      colorCode: "#fafafa",
      colorClass: "grey lighten-5",
      checkColor: "grey"
    }, {
      name: "verde",
      colorCode: "#4caf50",
      colorClass: "green",
      checkColor: "white"
    }, {
      name: "blu",
      colorCode: "#2196f3",
      colorClass: "blu",
      checkColor: "white"
    }, {
      name: "giallo",
      colorCode: "#FFEB3B",
      colorClass: "yellow",
      checkColor: "grey"
    }, {
      name: "rosso",
      colorCode: "#f44336",
      colorClass: "red",
      checkColor: "white"
    }, {
      name: "rosa",
      colorCode: "#F8BBD0",
      colorClass: "pink",
      checkColor: "white"
    }, {
      name: "arancione",
      colorCode: "#FF9800",
      colorClass: "orange",
      checkColor: "white"
    }, {
      name: "viola",
      colorCode: "#AB47BC",
      colorClass: "purple",
      checkColor: "white"
    }, {
      name: "oro",
      colorCode: "#FFD700",
      colorClass: "gold",
      checkColor: "white"
    }, {
      name: "argento",
      colorCode: "#D3D3D3",
      colorClass: "silver",
      checkColor: "white"
    }, {
      name: "azzurro",
      colorCode: "#81D4FA",
      colorClass: "light blue",
      checkColor: "white"
    }, {
      name: "",
      colorCode: "",
      colorClass: "no color",
      checkColor: ""
    }];
    this.layouts = [{
      name: "CILIARE",
      activeMenu: config.nome_ciliare,
      positionName: "ciliare",
      keyName: 'frontali',
      nomeGet: 'frontali',
      moduleName: 'configurator/frontali',
      previewComponent: PersonalNamePreview,
      colorMutation: 'setNameColor',
      nameMutation: 'setName',
      fieldGetterName: 'name',
      fieldGetterColor: 'nameColor'
    }, {
      name: "ASTA DESTRA",
      activeMenu: config.nome_extdx,
      positionName: "astaDx",
      keyName: 'aste',
      nomeGet: 'aste',
      moduleName: 'configurator/aste',
      previewComponent: ExtAstaDxPreview,
      colorMutation: 'setExtDxNameColor',
      nameMutation: 'setExtDxName',
      fieldGetterName: 'extDxName',
      fieldGetterColor: 'extDxNameColor'
    }, {
      name: "ASTA SINISTRA",
      activeMenu: config.nome_extsx,
      positionName: "astaSx",
      keyName: 'aste',
      nomeGet: 'aste',
      moduleName: 'configurator/aste',
      previewComponent: ExtAstaSxPreview,
      colorMutation: 'setExtSxNameColor',
      nameMutation: 'setExtSxName',
      fieldGetterName: 'extSxName',
      fieldGetterColor: 'extSxNameColor'
    }];
    this.isMobile = false;
    this.carouselIndex = 0;
  }
  mounted() {
    this.isMobile = window.innerWidth < 768;
  }
  beforeDestroy() {
    // Rimuovo l'event listener quando il componente viene distrutto
    window.removeEventListener('resize', this.checkIfMobile);
  }
  checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }
  get config() {
    return config;
  }
  previousSection() {
    this.carouselIndex = (this.carouselIndex - 1 + this.filteredLayouts.length) % this.filteredLayouts.length;
  }
  nextSection() {
    this.carouselIndex = (this.carouselIndex + 1) % this.filteredLayouts.length;
  }
  get coloreAste() {
    const coloreAstePreview = this.$store.getters.coloreAste;
    return coloreAstePreview ? coloreAstePreview.U_THE_COLORE : ''; // Gestisci il caso in cui `coloreAste` sia null o undefined
  }
  get filteredLayouts() {
    return this.layouts.filter(layout => layout.activeMenu);
  }
  get activeMenu() {
    var _this$filteredLayouts;
    return ((_this$filteredLayouts = this.filteredLayouts[this.carouselIndex]) === null || _this$filteredLayouts === void 0 ? void 0 : _this$filteredLayouts.positionName) || '';
  }
  set activeMenu(value) {
    this.carouselIndex = this.filteredLayouts.findIndex(section => section.positionName === value);
  }
  setActiveMenu(menu) {
    this.activeMenu = menu;
  }
  getSelectedColor(index) {
    const keyName = this.filteredLayouts[index].keyName;
    const configState = this.$store.state.configurator[keyName];
    if (!configState || !configState.color) {
      return null;
    }
    return this.colors.find(c => c.name === configState.color) || null;
  }
  get darkThemeValue() {
    return this.darkTheme ? 'dark' : 'light';
  }
  onFilteredLayoutsChange() {
    if (this.carouselIndex >= this.filteredLayouts.length) {
      this.carouselIndex = 0;
    }
  }
};
__decorate([Prop({
  default: false
})], PersonalName.prototype, "darkTheme", void 0);
__decorate([Watch('filteredLayouts')], PersonalName.prototype, "onFilteredLayoutsChange", null);
PersonalName = __decorate([Component({
  components: {
    CustomLayout,
    PersonalNamePreview,
    ExtAstaDxPreview,
    ExtAstaSxPreview
  },
  filters: {
    upperCase(s) {
      return s.toUpperCase();
    }
  }
})], PersonalName);
export default PersonalName;